import { AdminClient } from '@liquid-state/pip-client';
import { pipApiRoot } from 'settings';
export { PIPObject } from '@liquid-state/pip-client/dist/types';

export default async tokens => {
  const pipToken = await tokens.get('pip');
  return new AdminClient({ jwt: pipToken }, { apiRoot: pipApiRoot });
};
